module.exports = __webpack_public_path__ + "static/media/Varys 3.ad6415d1.jpg";